
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sign-up/code/[signUpCode]",
      function () {
        return require("private-next-pages/sign-up/code/[signUpCode].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sign-up/code/[signUpCode]"])
      });
    }
  